import React from "react";
import house6 from "../../assets/house-6.jpg";

const ArrowRight = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path d="M1 7h12m-4-4 4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TEAM = [
  {
    name: "Margaret E. Law",
    title: "President, Preferred Title & Escrow, Inc.",
    credentials: [
      "BA University of Maryland, College Park",
      "Certified Paralegal, University of Maryland University College, 1976",
    ],
    bio: "Ms. Law has been a manager/owner in the real estate industry since 1972. She started by opening a title company division for an attorney which was a great success and has been working in real estate ever since. She has handled all aspects of the settlement business from typing documents to solving complex title problems. As Pre Settlement Manager and owner of Preferred Title & Escrow, Inc., Ms. Law takes a very hands on approach and is very active in resolving title problems and in ensuring that clients get what they need in a timely manner.",
  },
  {
    name: "Kathi Redford",
    title: "Vice President, Preferred Title & Escrow, Inc.",
    credentials: [
      "BA University of Maryland, 1987",
    ],
    bio: "Ms. Redford has been working in the real estate field since 1983. She worked her way through college at a real estate settlement attorney's office and was manager of the office before she graduated. She has handled all aspects of real estate settlements and specializes in the closing of transactions and follow-up work. As post closing manager she reviews all transactions which close at Preferred Title to ensure that everything is recorded properly and that the title insurance is issued as soon as possible.",
  },
  {
    name: "Robert H. Law, Esquire",
    title: "Counsel",
    credentials: [
      "BA University of West Virginia, 1956",
      "JD American University, 1961",
      "Admitted to Maryland Bar, June 1962",
    ],
    bio: "Mr. Law is an attorney who has been practicing in Maryland since 1962. He is the Senior Member of his Law Firm. He has handled all aspects of the law including real estate contract law. He has worked both with residential and commercial real estate and has handled real estate settlements over several decades. His practice consists mainly of real estate, corporate law, and business law.",
  },
];

export default function OurTeam() {
  return (
    <div>
      {/* Hero */}
      <section style={{
        position: "relative",
        backgroundImage: `url(${house6})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: 400,
        display: "flex",
        alignItems: "flex-end",
        padding: "0 64px 64px",
      }} className="pte-ot-hero">
        <div style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(180deg, rgba(63,15,18,.3) 0%, rgba(63,15,18,.75) 100%)",
        }} />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div className="eyebrow" style={{ color: "var(--gold)", marginBottom: 16 }}>Company</div>
          <h1 style={{ color: "var(--cream)", fontSize: 72, lineHeight: 1, marginBottom: 16 }}>Our Team</h1>
          <p style={{ color: "rgba(246,237,228,.8)", fontSize: 18, maxWidth: 560, lineHeight: 1.55 }}>
            The principals of Preferred Title &amp; Escrow have not changed since the company was formed in 1990.
            Over 45 years of combined experience in the title industry.
          </p>
        </div>
      </section>

      {/* History */}
      <section style={{ padding: "80px 64px" }} className="pte-ot-history">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.6fr", gap: 80, alignItems: "start" }}>
          <div>
            <div className="eyebrow" style={{ marginBottom: 16 }}>Our story</div>
            <h2 style={{ fontSize: 48, lineHeight: 1.05 }}>
              Three decades<br />of trusted service.
            </h2>
          </div>
          <p style={{ fontSize: 17, color: "var(--ink-soft)", lineHeight: 1.7, paddingTop: 8 }}>
            Since 1992, the same principals have guided Preferred Title &amp; Escrow through thousands of
            residential and commercial closings across Maryland and the District of Columbia. Our team brings
            decades of hands-on experience in every aspect of the settlement process — from title examination
            and document preparation to coordinating with agents, lenders, and attorneys to keep every
            transaction on track.
          </p>
        </div>
      </section>

      {/* Team members */}
      <section style={{
        padding: "0 64px 100px",
        borderTop: "1px solid var(--line)",
      }} className="pte-ot-team">
        <div style={{ paddingTop: 80, marginBottom: 56 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>The principals</div>
          <h2 style={{ fontSize: 48 }}>People behind your closing.</h2>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 1, background: "var(--line)", border: "1px solid var(--line)", borderRadius: 8, overflow: "hidden" }}>
          {TEAM.map((member, i) => (
            <div key={i} style={{
              background: "var(--paper)",
              padding: "48px 48px",
              display: "grid",
              gridTemplateColumns: "280px 1fr",
              gap: 48,
              alignItems: "start",
            }} className="pte-ot-member">
              {/* Left: name + title + credentials */}
              <div>
                <h3 style={{ fontSize: 28, marginBottom: 8 }}>{member.name}</h3>
                <div style={{
                  fontFamily: "var(--mono)",
                  fontSize: 11,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  color: "var(--gold-deep)",
                  marginBottom: 20,
                  lineHeight: 1.5,
                }}>
                  {member.title}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {member.credentials.map((c, j) => (
                    <div key={j} style={{ fontSize: 13, color: "var(--ink-soft)", lineHeight: 1.4 }}>{c}</div>
                  ))}
                </div>
              </div>

              {/* Right: bio */}
              <p style={{ fontSize: 16, color: "var(--ink-soft)", lineHeight: 1.7, paddingTop: 4 }}>
                {member.bio}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: "0 64px 100px" }} className="pte-ot-cta">
        <div className="map-bg" style={{ borderRadius: 12, padding: "64px 64px", color: "var(--cream)" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 48, alignItems: "center" }} className="pte-ot-cta-inner">
            <div>
              <div className="eyebrow" style={{ color: "var(--gold)", marginBottom: 16 }}>Ready to close?</div>
              <h2 style={{ color: "var(--cream)", fontSize: 52, lineHeight: 1.02, marginBottom: 16 }}>
                Let&rsquo;s work together.
              </h2>
              <p style={{ fontSize: 17, opacity: 0.85, maxWidth: 480, lineHeight: 1.55, color: "var(--cream)" }}>
                Same-day quote response. Competitive fees. Friendly, knowledgeable staff before and after closing.
              </p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12, flexShrink: 0 }}>
              <a href="https://preferredtitle.titlecapture.com/title-quote" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ padding: "16px 32px", fontSize: 15 }}>
                Request a free quote <ArrowRight />
              </a>
              <a href="tel:3015139090" className="btn btn-ghost" style={{ padding: "16px 32px", fontSize: 15, borderColor: "rgba(246,237,228,.3)", color: "var(--cream)" }}>
                Call (301) 513-9090
              </a>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .pte-ot-hero { padding: 0 20px 48px !important; min-height: 320px !important; }
          .pte-ot-hero h1 { font-size: 48px !important; }
          .pte-ot-history { padding: 56px 20px !important; }
          .pte-ot-history > div { grid-template-columns: 1fr !important; gap: 24px !important; }
          .pte-ot-history h2 { font-size: 36px !important; }
          .pte-ot-team { padding: 0 20px 80px !important; }
          .pte-ot-team > div:first-child { padding-top: 56px !important; }
          .pte-ot-team h2 { font-size: 36px !important; }
          .pte-ot-member { grid-template-columns: 1fr !important; padding: 32px 24px !important; gap: 24px !important; }
          .pte-ot-cta { padding: 0 20px 80px !important; }
          .pte-ot-cta > div { padding: 40px 28px !important; }
          .pte-ot-cta-inner { grid-template-columns: 1fr !important; gap: 32px !important; }
          .pte-ot-cta h2 { font-size: 36px !important; }
        }
      `}</style>
    </div>
  );
}
